import * as React from "react";
import { useButton } from "@react-aria/button";
import { Icon, IconName } from "@nju/icons";

interface IArrowProps {
  onPress: () => void;
  title: string;
  iconName: IconName;
  className?: string;
}

export function Arrow({ iconName, className, title, onPress }: IArrowProps) {
  const innerRef = React.useRef<HTMLButtonElement>(null);
  const { buttonProps } = useButton({ onPress }, innerRef);

  return (
    <button
      className={`bg-transparent relative ${className || ""}`}
      ref={innerRef}
      title={title}
      {...buttonProps}
    >
      <Icon height={14} name={iconName} width={14} />
    </button>
  );
}
